export default "__VITE_ASSET__KWYmQvqM__"